import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'
import { ReactElement, useCallback, useState } from 'react'
import SimplePopup from './SimplePopup'

export interface IJSONDataTypeProps {
    dataKey: any
    dataValue: any
}

const JSONTypeData = (props: IJSONDataTypeProps): ReactElement => {
    const { dataKey, dataValue } = props
    const [isJsonOpen, setIsJsonOpen] = useState(false)
    const [viewJsonValue, setViewJsonValue] = useState('')
    const [viewJsonTitle, setViewJsonTitle] = useState('')
    const onOpenJsonView = useCallback(() => {
        let selectedCellValue = dataValue
        try {
            selectedCellValue = JSON.stringify(
                JSON.parse(selectedCellValue),
                null,
                2,
            )
        } catch (e) {
            console.log('Json type error:', e)
        }
        setIsJsonOpen(true)
        setViewJsonValue(selectedCellValue)
        setViewJsonTitle(dataKey)
    }, [dataKey, dataValue])
    return (
        <Box
            onClick={onOpenJsonView}
            sx={{
                color: '#6d6dff',
                cursor: 'pointer',
                width: '100%',
            }}
        >
            <TruncatedText
                sx={{ fontSize: '14px' }}
                text={dataValue ? 'View Json' : ''}
            />
            {isJsonOpen && (
                <SimplePopup
                    isOpen={isJsonOpen}
                    onClickBack={() => {
                        setIsJsonOpen(false)
                        setViewJsonValue('')
                        setViewJsonTitle('')
                    }}
                    title={viewJsonTitle}
                >
                    <Box sx={{ height: '100%' }}>
                        <textarea
                            style={{
                                width: '100%',
                                maxWidth: '100%',
                                minWidth: '100%',
                                height: '100%',
                                borderRadius: '4px',
                                borderColor: 'rgb(0 0 0 / 25%)',
                            }}
                            value={viewJsonValue}
                            disabled
                        />
                    </Box>
                </SimplePopup>
            )}
        </Box>
    )
}

export default JSONTypeData
